import Med from "./Med";

export default Med;
